//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import { initialiseForm } from "@donutteam/document-builder-components/build/client.js";

import { createBlogPost } from "../../../api/routes/v7/blogPost/create.schemas.js";
import { updateBlogPost } from "../../../api/routes/v7/blogPost/update.schemas.js";

//
// Locals
//

//
// Component
//

export async function initialiseUpsertBlogPostForm(upsertBlogPostForm: HTMLFormElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(upsertBlogPostForm, "apiUrl");
	const homepageUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(upsertBlogPostForm, "homepageUrl");
	const blogPostId = BrowserUtilities.ElementClientLib.getIntegerData(upsertBlogPostForm, "blogPostId");

	const titleInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(upsertBlogPostForm, `[name="title"]`);
	const authorUserIdsMultiInput = BrowserUtilities.ElementClientLib.getElementOrThrow(upsertBlogPostForm, `.component-multi-input[data-name="authorUserIds"]`);
	const topicsMultiInput = BrowserUtilities.ElementClientLib.getElementOrThrow(upsertBlogPostForm, `.component-multi-input[data-name="topics"]`);
	const summaryInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(upsertBlogPostForm, `[name="summary"]`);
	const urlInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(upsertBlogPostForm, `[name="url"]`);
	const forumTopicIdInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(upsertBlogPostForm, `[name="forumTopicId"]`);
	const contentsInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLTextAreaElement>(upsertBlogPostForm, `[name="contents"]`);
	const publishedStateSelect = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLSelectElement>(upsertBlogPostForm, `[name="publishedState"]`);

	const getAuthorUserIds = () =>
	{
		return Array.from(authorUserIdsMultiInput.querySelectorAll<HTMLInputElement>("input"))
			.map(input => parseInt(input.value))
			.filter(value => !isNaN(value));
	}

	const getForumTopicId = () =>
	{
		let forumTopicId: number | null = parseInt(forumTopicIdInput.value);

		return !isNaN(forumTopicId) ? forumTopicId : null;
	}

	const getTopics = () =>
	{
		return Array.from(topicsMultiInput.querySelectorAll<HTMLInputElement>("input")).map(input => input.value);
	}

	if (blogPostId == null)
	{
		initialiseForm(upsertBlogPostForm,
			async () =>
			{
				const response = await createBlogPost(apiUrl,
					{
						contents: contentsInput.value,
						publishedState: parseInt(publishedStateSelect.value),
						summary: summaryInput.value,
						title: titleInput.value,
						url: urlInput.value,

						authorUserIds: getAuthorUserIds(),
						forumTopicId: getForumTopicId(),
						topics: getTopics(),
					});

				if (!response.success)
				{
					return {
						restoreInputs: true,
						notices: response.errors.map(error => ({ type: "warning", message: error.message })),
					};
				}

				window.location.href = homepageUrl + "/blog-posts/view/" + urlInput.value;

				return {
					restoreInputs: false,
					notices: [],
				};
			});
	}
	else
	{
		initialiseForm(upsertBlogPostForm,
			async () =>
			{
				const response = await updateBlogPost(apiUrl,
					{
						blogPostId,
						contents: contentsInput.value,
						publishedState: parseInt(publishedStateSelect.value),
						summary: summaryInput.value,
						title: titleInput.value,
						url: urlInput.value,

						authorUserIds: getAuthorUserIds(),
						forumTopicId: getForumTopicId(),
						topics: getTopics(),
					});

				if (!response.success)
				{
					return {
						restoreInputs: true,
						notices: response.errors.map(error => ({ type: "warning", message: error.message })),
					};
				}

				window.location.href = homepageUrl + "/blog-posts/view/" + urlInput.value;

				return {
					restoreInputs: false,
					notices: [],
				};
			});
	}

	upsertBlogPostForm.classList.add("initialised");
}

export async function initialiseUpsertBlogPostForms()
{
	const upsertBlogPostForms = document.querySelectorAll<HTMLFormElement>(".component-upsert-blog-post-form:not(.initialised)");

	console.log("[UpsertBlogPostForm] Initialising " + upsertBlogPostForms.length + " instances...");

	for (const upsertBlogPostForm of upsertBlogPostForms)
	{
		try
		{
			await initialiseUpsertBlogPostForm(upsertBlogPostForm);
		}
		catch (error)
		{
			console.error("[UpsertBlogPostForm] Error initialising:", upsertBlogPostForm, error);
		}
	}
}